import type { NavigateFunction } from "react-router";

let navigateRef: NavigateFunction | null = null;

export function setNavigateRef(navigate: NavigateFunction) {
  navigateRef = navigate;
}

export function navigateTo(path: string) {
  if (navigateRef) {
    navigateRef(path, { replace: true });
  } else {
    window.location.href = path;
  }
}
